import { FC, ReactNode } from 'react';

import { styled } from '@mui/material/styles';
import Box, { BoxProps } from '@o2/ui/Box';

import RowBreak from './RowBreak';

export interface PageActionButtonContainerProps extends BoxProps {
  children?: ReactNode;
}

const ContainerRoot = styled(Box)(({ theme }) => ({
  display: 'grid',
  gap: theme.spacing(1),
  gridTemplateColumns: '1fr',
  [theme.breakpoints.only('sm')]: {
    gridTemplateColumns: 'repeat(3, 1fr)',
  },
  [theme.breakpoints.up('md')]: {
    gridTemplateColumns: 'repeat(5, 1fr)',
  },
}));

type ContainerComponent = FC<PageActionButtonContainerProps> & {
  RowBreak: typeof RowBreak;
};

/**
 * A container for LinkBoxes used at the top of the page, for example in Vyuctovani.
 *
 * This component takes care of spacing, preserving width and reflowing content on mobile.
 */
const PageActionButtonContainer: ContainerComponent = (props) => {
  return <ContainerRoot {...props} />;
};

PageActionButtonContainer.RowBreak = RowBreak;

export default PageActionButtonContainer;
